<template>
  <div class="form-coms ui-search">
    <div class="form-label" v-if="$attrs.label">{{ $attrs.label }}</div>
    <div :id="id" class="--search">
      <input
        type="text"
        v-bind="$attrs"
        v-model="inputText"
        :style="{ width: width }"
        @keyup="Search"
        @focus="showPopover = true"
      />
      <v-icon
        class="ui-search-icon"
        v-show="!inputText && !loading"
        @click="SearchWithShow"
      >
        search
      </v-icon>
      <v-icon
        class="ui-clear-icon"
        v-show="inputText && !loading"
        @click="SearchWithShow"
      >
        clear
      </v-icon>
      <v-icon class="ui-clear-icon" v-show="loading">
        mdi-loading mdi-spin
      </v-icon>
      <Popover
        :targetId="id"
        :show.sync="showPopover"
        posmode="absolute"
        :style="{ minWidth: width }"
        @onShow="handlePopoverShow"
        @onHide="handlePopoverHide"
      >
        <template>
          <div
            v-for="(item, idx) in options"
            :key="idx"
            class="ui-search--item popover-close"
            @click="handleItemClick(item)"
          >
            <slot :row="item">
              <div class="ui-search--item-inner">
                {{ item[_textKey] }}
              </div>
            </slot>
          </div>
        </template>
      </Popover>
    </div>
  </div>
</template>

<script>
import Popover from './Popover'
export default {
  components: {
    Popover,
  },
  name: 'Input',
  data: () => ({
    options: [],
    allOptions: [],
    id: null,
    val: '',
    inputText: '',
    timeRef: null,
    showPopover: false,
    loading: false,
  }),
  props: {
    value: [String, Number, Object],
    text: [String, Number],
    width: String,
    valueKey: String,
    textKey: String,
    dataKey: String,
    dbref: [String, Object],
    dbparams: Object,
    rebind: [String, Number],
    offline: Boolean,
    valueAsObject: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _valueKey() {
      return this.valueKey || Object.keys(this.options[0])[0]
    },
    _textKey() {
      return this.textKey || Object.keys(this.options[0])[1]
    },
  },
  watch: {
    text(val) {
      this.inputText = val
    },
    value(val) {
      this.val = val
      if (!val && !this.text) this.inputText = ''
    },
    rebind() {
      this.doRebind()
    },
    showPopover(val) {
      if (val) this.handlePopoverShow()
    },
  },
  async created() {
    if (!window.uuid) window.uuid = 0
    this.id = 'search-' + ++window.uuid

    this.doRebind()
  },
  methods: {
    Search() {
      if (this.timeRef) clearTimeout(this.timeRef)
      this.timeRef = setTimeout(async () => {
        this.loading = true
        let ret = []
        this.$emit('update:text', this.inputText)
        if (this.offline) {
          let rx = new RegExp(this.inputText, 'i')
          this.options = this.allOptions.filter(o => {
            return o[this._textKey].match && o[this._textKey].match(rx)
          })
          return
        }
        if (typeof this.dbref == 'object') {
          var opts = { ...this.dbref }
          if (typeof opts.url == 'function') opts.url = opts.url(this.inputText)
          ret = await this.$api.fromOutside(opts)
          this.options = opts.parseData(ret)
          this.showPopover = true
        } else {
          // if (this.inputText) {
          ret = await this.$api.call(this.dbref, {
            ...this.dbparams,
            Keyword: this.inputText,
          })
          this.options = ret.data
          this.showPopover = true
          this.handlePopoverShow()
          // }
        }
        this.loading = false
      }, 800)
    },
    handleItemClick(item) {
      this.inputText = item[this._textKey]
      if (this.valueAsObject) this.$emit('update:value', item)
      else {
        this.$emit('update:value', item[this._valueKey])
        this.$emit('update:text', item[this._textKey])
      }
      this.$emit('change', item)
      this.showPopover = false
    },
    SearchWithShow() {
      this.inputText = ''
      this.Search()
      this.showPopover = true
    },
    handlePopoverShow() {
      setTimeout(() => {
        let $t = document.querySelector(`#${this.id} input`)
        let $p = document.querySelector(`#${this.id}_popover`)
        const rect = $t.getBoundingClientRect()

        // $p.style.marginBottom = $p.clientHeight * -1 + 'px'
        $p.style.minWidth = $t.clientWidth + 'px'
        $p.style.width = $t.clientWidth + 'px'
        if (rect.top > 600) $p.style.top = rect.top - $p.clientHeight + 'px'
        else $p.style.top = rect.top + $t.clientHeight + 'px'
      }, 1)
    },
    handlePopoverHide() {
      this.showPopover = false
    },
    async doRebind() {
      if (this.dbref) {
        let opts = await this.$api.call(this.dbref, { ...this.dbparams })
        if (opts.data.length) {
          this.options = opts.data
          if (this.offline) this.allOptions = opts.data
        }
      }
    },
  },
}
</script>
<style lang="scss">
.ui-search {
  margin-bottom: 8px;

  .form-label {
    text-align: left;
    font-size: 14px;
  }
  .--search {
    input {
      padding: 4px 5px;
      background: rgba(200, 200, 200, 0.2);
      font-size: 14px;
      border-radius: 2px;
      width: 180px;
      border-bottom: 1px solid silver;
      padding-right: 35px;

      &:hover,
      &:focus {
        border: 0;
        background: rgba(200, 200, 200, 0.4);
        border-bottom: 1px solid gray;
      }
    }
    .ui-search-icon,
    .ui-clear-icon {
      position: relative;
      left: -30px;
      margin-right: -25px;
    }
    .ui-clear-icon {
      color: silver;
    }
    .ui-popover {
      border: 1px solid silver;
      max-height: 200px;
      overflow: auto;
      // position: fixed;
      // position: relative;
      position: absolute;
      .ui-search--item {
        padding: 0 8px;
        cursor: pointer;
        width: 100%;
        &-inner {
          padding: 5px 0;
          border-bottom: 1px solid #ddd;
          text-align: left;
          font-size: 12px;
          text-overflow: ellipsis;
          white-space: nowrap;
          // max-width: 350px;
          max-width: 100%;
          overflow: hidden;
        }
        &:last-child {
          .ui-dropdown--item-inner {
            border-bottom-color: transparent;
          }
        }
        &:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
}
</style>
